/**
 * Constants for step-up authentication
 */

/**
 * Maximum age in minutes for step-up authentication validity
 * Must match backend StepUpAuthConstants.DefaultMaxAgeMinutes
 */
export const STEP_UP_MAX_AGE_MINUTES = 5;

/**
 * Cooldown period in milliseconds before allowing another automatic redirect
 * Prevents infinite redirect loops
 */
export const REDIRECT_COOLDOWN_MS = 30000; // 30 seconds

/**
 * Maximum number of automatic redirect attempts before showing manual button
 */
export const MAX_REDIRECT_ATTEMPTS = 1;
